import { render, staticRenderFns } from "./TillDetail.vue?vue&type=template&id=455d59be&scoped=true&"
import script from "./TillDetail.vue?vue&type=script&lang=js&"
export * from "./TillDetail.vue?vue&type=script&lang=js&"
import style0 from "./TillDetail.vue?vue&type=style&index=0&id=455d59be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455d59be",
  null
  
)

export default component.exports